export enum InterviewStage {
  Recruiter = 'Recruiter',
  // TODO: add the rest of options here
}
